import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { useRef, useState } from "react";
import { Popover, PopoverAnchor, PopoverContent } from ".";
import classnames from "classnames";
import ResetState from "./resetstate";

const SelectInput = ({
  className,
  classNameAnchor,
  classNameContent,
  value,
  onChange,
  label = "",
  options = [],
  defaultValue,
  resetValue = "",
  activeStyles = {
    backgroundColor: "var(--color-ui-light-blue-background)",
    color: "var(--color-ui-blue)",
  },
  isResetVisible = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef();

  if (value === undefined || value === null) {
    value = "";
  }

  const handleSelect = (selected) => {
    setIsOpen(!isOpen);
    onChange(selected.value);
  };

  const classes = classnames("relative", className);

  const classesAnchor = classnames(
    "editor-input-box cursor-pointer p-2 px-5 bg-ui-light-white flex items-center rounded-full",
    classNameAnchor,
  );

  const classesContent = classnames(
    "!z-[1000] !w-[274px] outline-none absolute top-12 bg-ui-light-white !rounded-[21px] p-3 px-0 flex border flex-col gap-1 grigora-custom-scrollbar overflow-auto",
    classNameContent,
  );

  return (
    <div className="text-grigora-base">
      <div className="text-ui-text-heading mb-2 flex flex-row justify-between items-center">
        {label}
        {isResetVisible && (
          <ResetState
            active={value != resetValue}
            onClick={(e) => {
              onChange(resetValue);
            }}
          />
        )}
      </div>
      <div className={classes}>
        <Popover open={isOpen} onOpenChange={setIsOpen}>
          <PopoverAnchor
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            className={classesAnchor}
            position="bottom"
          >
            <div>
              {_.find(options, (option) => option.value === value)?.label ??
                "-"}
            </div>
            <div className="ml-auto">
              <FontAwesomeIcon
                className={`duration-300 ${isOpen ? "" : "rotate-180"}`}
                icon={faChevronUp}
              />
            </div>
          </PopoverAnchor>
          <PopoverContent ref={selectorRef} className={classesContent}>
            {options.map((item) => {
              return (
                <div
                  key={item.value}
                  className={`text-sm cursor-pointer py-1 px-5 duration-300 font-medium text-ui-text-secondary hover:text-ui-blue`}
                  style={item.value === value ? activeStyles : {}}
                  onClick={() => {
                    handleSelect(item);
                  }}
                >
                  {item.component ? item.component : item.label}
                </div>
              );
            })}
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
};

export default SelectInput;
